import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faCheckSquare,
  faGear,
  faChevronDown,
  faChartColumn,
  faSearch,
  faArrowCircleLeft,
  faPlusCircle,
  faTimesCircle,
  faPen,
  faCalendar,
  faBuilding,
  faLayerGroup,
  faUpload,
  faXmark,
  faEye,
  faEyeSlash,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faSortDown,
  faArrowRight,
  faSortUp,
  faSort,
  faFilter,
  faBars,
  faClipboard,
  faChevronLeft,
  faTrash,
  faChevronRight,
  faCalendarCheck,
  faMobilePhone,
  faFolderOpen,
  faLocationDot,
  faListCheck,
  faUserGroup,
  faUsers,
  faSuitcase,
  faHouseMedical,
  faQuestionCircle,
  faW,
  faPlay,
  faDownload, faCalculator, faComment, faCheck, faStar, faList, faLock
} from "@fortawesome/free-solid-svg-icons";
import {
  faEnvelope,
  faBell,
  faUser,
  faChartBar,
  faHandshake,
  faListAlt,
  faCreditCard,
  faFileLines,
  faCheckCircle,
  faClock,
  faSun,
  faMoon,
} from "@fortawesome/free-regular-svg-icons";

library.add(
  faW,
  faCheckSquare,
  faEnvelope,
  faBell,
  faClipboard,
  faChartBar,
  faChevronLeft,
  faTrash,
  faChevronRight,
  faUser,
  faUsers,
  faHandshake,
  faListAlt,
  faCreditCard,
  faMobilePhone,
  faFolderOpen,
  faFileLines,
  faGear,
  faChevronDown,
  faChartColumn,
  faSearch,
  faArrowCircleLeft,
  faPlusCircle,
  faTimesCircle,
  faPen,
  faArrowRight,
  faCalendar,
  faBuilding,
  faLocationDot,
  faLayerGroup,
  faUpload,
  faXmark,
  faCheckCircle,
  faEye,
  faEyeSlash,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faSortDown,
  faSortUp,
  faSort,
  faFilter,
  faBars,
  faCalendarCheck,
  faListCheck,
  faUserGroup,
  faClock,
  faSuitcase,
  faHouseMedical,
  faQuestionCircle,
  faPlay,
  faSun,
  faMoon,
  faDownload,
  faCalculator,
  faComment,
    faCheck,faStar, faList, faLock
);

export default library;

// Icon usage example:
// <FontAwesomeIcon icon={["far", "bell"]} />
